import React from 'react';
import { formatEngagementMeta } from '../utils/engagementMeta';

interface VehicleEngagementMetaProps {
  viewCount?: number | null;
  likeCount?: number | null;
  favoriteCount?: number | null;
  className?: string;
}

/** Secondary engagement line: views · likes · favorites */
export const VehicleEngagementMeta: React.FC<VehicleEngagementMetaProps> = ({
  viewCount = 0,
  likeCount = 0,
  favoriteCount = 0,
  className = '',
}) => {
  const text = formatEngagementMeta(viewCount ?? 0, favoriteCount ?? 0, likeCount ?? 0);
  return (
    <p className={`text-xs text-gray-500 ${className}`.trim()} aria-label={text}>
      {text}
    </p>
  );
};

export default VehicleEngagementMeta;
